import React from 'react';

import { SecondaryButton } from '@components/Button/variants';

import { LOAD_MORE_BUTTON_TEXT } from './constants';
import type { LoadMoreButtonProps } from './interfaces';

const LoadMoreButton = ({ handleLoadMore }: LoadMoreButtonProps) => {
  return (
    <SecondaryButton
      as="button"
      className="mx-auto mt-36 max-w-[850px] sm:mt-48"
      onClick={handleLoadMore}
      size="small"
      fullWidth
    >
      {LOAD_MORE_BUTTON_TEXT}
    </SecondaryButton>
  );
};

export default LoadMoreButton;
